var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$props.itemDetail.componentSubcode === "s_4" ||
    _vm.$props.itemDetail.componentSubcode === "d_8"
      ? _c(
          "div",
          {
            staticClass: "father-box",
            style: {
              borderRadius:
                _vm.$props.itemDetail.horizontalMargin === 1 ? "8px" : 0,
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "flex-start",
                  "flex-wrap": "wrap",
                },
              },
              _vm._l(_vm.dataList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticStyle: {
                      width: "25%",
                      "text-align": "center",
                      "margin-top": "10px",
                    },
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "30px", height: "30px" },
                      attrs: {
                        src: item.bannerPic
                          ? item.bannerPic
                          : require("@/assets/customPage/icon.png"),
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "esp-text",
                        staticStyle: {
                          "font-size": "11px",
                          "text-align": "center",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(item.bannerName ? item.bannerName : "自定义")
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$props.itemDetail.componentSubcode === "s_5" ||
    _vm.$props.itemDetail.componentSubcode === "d_10"
      ? _c(
          "div",
          {
            staticClass: "father-box",
            style: {
              borderRadius:
                _vm.$props.itemDetail.horizontalMargin === 1 ? "8px" : 0,
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "flex-start",
                  "flex-wrap": "wrap",
                },
              },
              _vm._l(_vm.dataList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticStyle: {
                      width: "20%",
                      "text-align": "center",
                      "margin-top": "10px",
                    },
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "25px", height: "25px" },
                      attrs: {
                        src: item.bannerPic
                          ? item.bannerPic
                          : require("@/assets/customPage/icon.png"),
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "esp-text",
                        staticStyle: {
                          "font-size": "10px",
                          "text-align": "center",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(item.bannerName ? item.bannerName : "自定义")
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$props.itemDetail.componentSubcode === "s_a"
      ? _c(
          "div",
          {
            style: {
              borderRadius:
                _vm.$props.itemDetail.horizontalMargin === 1 ? "8px" : 0,
              background: "#fff",
            },
          },
          [
            _c(
              "el-carousel",
              {
                attrs: {
                  arrow: "never",
                  height: _vm.dataList.length > 5 ? "110px" : "55px",
                  "indicator-position": "outside",
                },
              },
              _vm._l(_vm.slideList, function (item, index) {
                return _c("el-carousel-item", { key: index }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-start",
                        "flex-wrap": "wrap",
                      },
                    },
                    _vm._l(item, function (m, n) {
                      return _c(
                        "div",
                        {
                          key: n,
                          staticStyle: {
                            width: "20%",
                            "text-align": "center",
                            "margin-top": "10px",
                          },
                        },
                        [
                          _c("img", {
                            staticStyle: { width: "25px", height: "25px" },
                            attrs: {
                              src: m.bannerPic
                                ? m.bannerPic
                                : require("@/assets/customPage/icon.png"),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "esp-text",
                              staticStyle: {
                                "font-size": "10px",
                                "text-align": "center",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(m.bannerName ? m.bannerName : "自定义")
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              }),
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$props.itemDetail.componentSubcode === "s_a_c"
      ? _c(
          "div",
          {
            style: {
              borderRadius:
                _vm.$props.itemDetail.horizontalMargin === 1 ? "8px" : 0,
              background: "#fff",
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "flex-start",
                  "flex-wrap": "wrap",
                },
              },
              [
                _vm._l(_vm.findListData, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: "cat-" + index,
                      staticClass: "category-item",
                      staticStyle: {
                        width: "20%",
                        "text-align": "center",
                        "margin-top": "10px",
                        "font-size": "10px",
                        "font-weight": "bold",
                        color: "#000",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(item.categoryName) + "\n        "
                      ),
                      index === 0
                        ? _c("div", {
                            staticStyle: {
                              width: "8px",
                              height: "2px",
                              "background-color": "red",
                              margin: "4px auto 0",
                              "border-radius": "1px",
                            },
                          })
                        : _vm._e(),
                    ]
                  )
                }),
                _vm._v(" "),
                _vm._l(_vm.dataList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticStyle: {
                        width: "20%",
                        "text-align": "center",
                        "margin-top": "10px",
                      },
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "25px", height: "25px" },
                        attrs: {
                          src: item.bannerPic
                            ? item.bannerPic
                            : require("@/assets/customPage/icon.png"),
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "esp-text",
                          staticStyle: {
                            "font-size": "10px",
                            "text-align": "center",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(item.bannerName ? item.bannerName : "自定义")
                          ),
                        ]
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }